import React from 'react';
import { z } from 'zod';

import { useRenderOutputEscapedString } from '@wp-block-builder/stores/WaypointRendererStore';

import defineBlock from './helpers/defineBlock';

export const HtmlBlockSchema = defineBlock('Html', z.object({ text: z.string().nullish() }));
export type THtmlBlock = z.infer<typeof HtmlBlockSchema>;

type HtmlBlockProps = {
  block: THtmlBlock;
  placeholder?: JSX.Element;
  skipLiquid: boolean;
};
export default function HtmlBlock({ block, placeholder, skipLiquid }: HtmlBlockProps) {
  if (skipLiquid) {
    return <RawLiquidHtmlBlock block={block} />;
  }
  return <ReadOnlyHtmlBlock block={block} placeholder={placeholder} />;
}

type ReadOnlyHtmlBlockProps = {
  block: THtmlBlock;
  placeholder?: JSX.Element;
};
function ReadOnlyHtmlBlock({ block, placeholder }: ReadOnlyHtmlBlockProps) {
  const children = useRenderOutputEscapedString(block.props?.text ?? '');
  if (!children || children.trim().length === 0) {
    return placeholder ?? null;
  }
  return <div dangerouslySetInnerHTML={{ __html: children }} />;
}

function RawLiquidHtmlBlock({ block }: { block: THtmlBlock }) {
  const children = block.props?.text ?? '';
  if (!children || children.trim().length === 0) {
    return null;
  }
  return <div dangerouslySetInnerHTML={{ __html: children }} />;
}
